<script setup>
import { ref } from 'vue'

import { DxDataGrid } from 'devextreme-vue/data-grid'

import { menuRoutesEnum } from '@/router'
import { useDocumentService } from '@/services/document.service'

import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'
import { usePortalStore } from '@/stores/portal.store'

import * as dataGrid from '@/composables/data-grid'
import { useColumns } from '@/composables/registry/vehicle-intervention-grid'

import ReferenceLink from '@/components/shared/ReferenceLink.vue'
import InformationToolTip from './InformationToolTip.vue'

const props = defineProps({
  vehicle: {
    type: Object,
    required: true
  },
})

const vehicleId = props.vehicle?.data?.id || props.vehicle?.id
const vehicle = props.vehicle?.data || props.vehicle
const gridId = 'vehicle-intervention-grid'
const gridRef = ref(null)

const registryStore = useRegistryStore()
const webSiteStore = useWebSiteStore()
const portalStore = usePortalStore()

const { extractReferenceData } = useDocumentService()

const currency = webSiteStore.currencies.find(i => i.id === vehicle.value?.currency_ref)

const gridDataSource = dataGrid.useODataSource(registryStore.api.getAbsoluteUrl() + registryStore.api.vehicleInterventionsUrl,
  { filter: ['vehicle', '=', vehicleId] }
)

const columns = useColumns(currency)

const onInitNewRow = (e) => {}

const gridOptions = dataGrid.useDefaultGridOptions({
  id: gridId,
  dataSource: gridDataSource,
  columns: columns,
  editing: {
    allowUpdating: false,
    allowDeleting: false,
    allowAdding: false
  },
  paging: { enabled: false },
  pager: { visible: false },
  columnChooser: { enabled: false },
  height: '100%',
  onInitNewRow: onInitNewRow,
})

</script>
<template>
  <div>
    <dx-data-grid
      ref="gridRef"
      v-bind="gridOptions"
      class="q-mb-lg"
    >
      <template #documentRef="{ data: cellInfo }">
        <reference-link
          :data="{
            series: cellInfo.data.series,
            number: cellInfo.data.number_mnemonic
          }"
          :text-fields="['prefix', 'series', 'number']"
          :query-fields="['series', 'number']"
          :target="menuRoutesEnum.WORKSHEETS"
        >
          <information-tool-tip :data="extractReferenceData({ ...cellInfo.data, type: portalStore.documentTypesEnum.GARAGE_WORKSHEET })" />
        </reference-link>
      </template>
    </dx-data-grid>
  </div>
</template>
<style>
</style>
